import * as Config from '../../../config';
import React from 'react';
import { useSelector } from "react-redux";
import PropTypes from 'prop-types';
import '../common/Card.css';

import CoverSplit from '../common/CoverSplit';

function CardArtistLabel({
  title = null, to, type, width, className, style, coverClassName, images
}) {
  // Double Tap OR Normal Click OR Touch
  const storeRoute = useSelector(state => state.storeRoute);
  const allowAccess = useSelector(state => state.allowAccess);
  const openLink = () => {
    if (to && allowAccess) {
      storeRoute.goTo(to);
    }
  }

  return (
    <div className={`flexColumn CardBP ${className}`} style={style}>
      <CoverSplit 
        name={title} 
        images={images ? images : []} 
        size={width} 
        className={coverClassName} 
        onlyCover={true} 
        onClick={openLink} 
      />
      { title && <span id={`link-refC-`} style={{width: '96%'}} className={`card-title-v2 ${type} type-medium`} onClick={openLink}>{Config.limitString(title, 30)}</span> }
    </div>
  )
}

CardArtistLabel.propTypes = {
  title: PropTypes.string,
  to: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.any,
  images: PropTypes.array,
  style: PropTypes.object,
  className: PropTypes.string,
  coverClassName: PropTypes.string
}

export default CardArtistLabel;
